export default function () {
  /* 表格列头 */
  return [
    { type: "selection", width: 55 },
    { label: "序号", type: "index", width: 80 },
    // { label: "公众号ID", prop: "id", width: 300 },
    // { label: "公众号二维码", prop: "gzh_img", slots: "gzh_img", width: 200 },
    { label: "所属公众号", prop: "appid", width: 150, slots: "appid" },
    { label: "昵称", prop: "user_name", width: 120, slots: "user_name"  },
    { label: "用户小程序openid", prop: "openid", minWidth: 100, slots: "openid"  },
    { label: "用户公众号openid", prop: "gzh_openid", minWidth: 100, },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
      // slots: "state",
    },
    {
      label: "操作",
      prop: "operation",
      width: 150,
      slots: "operation",
      fixed: "right",
    },
  ];
}
